// extracted by mini-css-extract-plugin
module.exports = {"small-table":"style-small-table-1K5EV"};